import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { DateFormats } from 'vcp-common-ui-lib';
import { DetailsSidePanelTemplateComponent } from './details-side-panel-template.component';

@Component({
    selector: 'vc-details-side-panel',
    imports: [CommonModule, DetailsSidePanelTemplateComponent],
    templateUrl: './details-side-panel.component.html',
    styleUrls: ['./details-side-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsSidePanelComponent {
    readonly dateFormats: typeof DateFormats = DateFormats;

    createdOnText = translate('ACCOUNT.DETAILS.CREATED_ON');
    createdByText = translate('COMMON_UI.CREATED_BY');
    lastUpdatedOnText = translate('ACCOUNT.DETAILS.LAST_UPDATED_ON');
    lastUpdatedByText = translate('ACCOUNT.DETAILS.LAST_UPDATED_BY');

    @Input()
    createdOn!: string | Date;

    @Input()
    showCreatedOn: boolean = true;

    @Input()
    createdBy!: string;

    @Input()
    showCreatedBy: boolean = true;

    @Input()
    lastUpdatedOn!: string | Date;

    @Input()
    showLastUpdatedOn: boolean = true;

    @Input()
    lastUpdatedBy!: string;

    @Input()
    showLastUpdatedBy: boolean = true;

    @Input()
    dateFormat: DateFormats = DateFormats.LONG_ISO_MS;
}
